





















import axios from 'axios'
import {
  apiV1AdminRecommendPath,
} from '@/rails/routes'
import { Component } from 'vue-property-decorator'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import Recommend, {IRecommend} from '@/models/Recommend'
import RecommendJobList from '@/components/admin/recommends/JobList.vue'

@Component({
  components: {
    RecommendJobList
  }
})
export default class RecommendShow extends PageBase {
  recommend: Recommend = new Recommend()

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'おすすめ求人一覧',
        to: '/admin/recommends',
        exact: true
      },
      {
        text: 'おすすめ求人詳細'
      }
    ]
  }

  mounted(): void {
    super.mounted()
    this.reload()
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const recommend = await axios.get<IRecommend>(apiV1AdminRecommendPath(this.$route.params.id))
      this.recommend = new Recommend(recommend.data)
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }
}
